import React from 'react';

/**
 * Κοινά κομμάτια της σελίδας «Εκτυπωτές». Τα κουμπιά/πεδία (και Notice/StatusDot/Disclosure) ζουν από
 * 14/10/2026 στο shared/listPage/ui — ίδια σε όλες τις σελίδες της νέας εμφάνισης· εδώ απλώς
 * ξαναεξάγονται, ώστε τα αρχεία των εκτυπωτών (και τα tests τους) να μη χρειάζονται αλλαγή.
 */
export {
  INPUT_CLS, SELECT_CLS, GHOST_BTN, PRIMARY_BTN, DANGER_GHOST_BTN, ASIDE_BTN, ICON_BTN, Notice, StatusDot, Disclosure,
} from '../shared/listPage/ui';

/** Μικρή ετικέτα στη γραμμή εκτυπωτή (ρόλοι, χαρτί, συρτάρι, μπιπ). */
export const Tag: React.FC<{ children: React.ReactNode; strong?: boolean }> = ({ children, strong = false }) => (
  <span
    className={`inline-flex items-center gap-1 min-h-[24px] px-2 rounded-md text-xs font-medium ${strong
      ? 'bg-brand-soft text-brand'
      : 'bg-surface-3 text-t2'}`}
  >
    {children}
  </span>
);
